export default function Payment() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pagamento 100% Seguro
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Sua segurança é nossa prioridade! Trabalhamos com os métodos de pagamento mais confiáveis do mercado para você ter total tranquilidade.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 text-center hover:bg-white/15 transition-all">
            <div className="w-16 h-16 bg-indigo-900/50 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-indigo-700/30">
              <i className="ri-shield-check-line text-4xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Protegido</h3>
            <p className="text-gray-300 leading-relaxed">
              Seus dados e pagamentos totalmente protegidos com criptografia de ponta
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 text-center hover:bg-white/15 transition-all">
            <div className="w-16 h-16 bg-indigo-900/50 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-indigo-700/30">
              <i className="ri-hand-coin-line text-4xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Transparente</h3>
            <p className="text-gray-300 leading-relaxed">
              Sem taxas escondidas! Você sabe exatamente quanto vai pagar antes de confirmar
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 text-center hover:bg-white/15 transition-all">
            <div className="w-16 h-16 bg-indigo-900/50 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-indigo-700/30">
              <i className="ri-calendar-check-line text-4xl text-indigo-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Flexível</h3>
            <p className="text-gray-300 leading-relaxed">
              Diversas formas de pagamento para você escolher a que melhor se encaixa
            </p>
          </div>
        </div>

        <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 text-center">
          <p className="text-lg text-gray-200 mb-4">
            <strong className="text-indigo-400">PIX</strong> • <strong className="text-indigo-400">Cartão de Crédito</strong> • <strong className="text-indigo-400">Transferência</strong>
          </p>
          <p className="text-gray-300">
            Escolha a melhor forma de pagamento para você e fique tranquilo! 💳
          </p>
        </div>
      </div>
    </section>
  );
}
